import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { DeliveryEndpointItem } from "../listing/DeliveryEndpointItem";

interface IDeliveryEndpointContext {
    deliveryEndpointItems: DeliveryEndpointItem[];
    isLoading: boolean;
    addSmartjogDeliveryEndpointItem(item: DeliveryEndpointItem): void;
    updateSmartjogDeliveryEndpointItem(item: DeliveryEndpointItem): void;
    addSigniantDeliveryEndpointItem(item: DeliveryEndpointItem): void;
    updateSigniantDeliveryEndpointItem(item: DeliveryEndpointItem): void;
    addAsperaDeliveryEndpointItem(item: DeliveryEndpointItem): void;
    updateAsperaDeliveryEndpointItem(item: DeliveryEndpointItem): void;
}

const initialContextState: IDeliveryEndpointContext = {
    deliveryEndpointItems: [],
    isLoading: false,
    addSmartjogDeliveryEndpointItem: contextFunctionInit,
    updateSmartjogDeliveryEndpointItem: contextFunctionInit,
    addSigniantDeliveryEndpointItem: contextFunctionInit,
    updateSigniantDeliveryEndpointItem: contextFunctionInit,
    addAsperaDeliveryEndpointItem: contextFunctionInit,
    updateAsperaDeliveryEndpointItem: contextFunctionInit
};

export const DeliveryEndpointContext = createContext<IDeliveryEndpointContext>(initialContextState);
